// extracted by mini-css-extract-plugin
export var borderBottom = "DesktopSection-module--borderBottom--a5a33";
export var boxes = "DesktopSection-module--boxes--182ba";
export var fadeInAnimation = "DesktopSection-module--fadeInAnimation--da0cf";
export var footer = "DesktopSection-module--footer--15a22";
export var lastRow = "DesktopSection-module--lastRow--39fde";
export var section = "DesktopSection-module--section--84db8";
export var showAll = "DesktopSection-module--showAll--c187c";
export var shrink = "DesktopSection-module--shrink--ad654";
export var subtitle = "DesktopSection-module--subtitle--23030";
export var title = "DesktopSection-module--title--9d18f";
export var twoColumnsSection = "DesktopSection-module--twoColumnsSection--c532a";
export var withMT = "DesktopSection-module--withMT--9e5a9";
export var withoutMT = "DesktopSection-module--withoutMT--5b808";
export var wrapper = "DesktopSection-module--wrapper--b978b";